
if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };

        this.hasCustomFields = !!document.querySelector(
          ".m-main-product--info .m-product-custom-field"
        );
      }

      connectedCallback() {
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']"
        );

        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(
          ".m-product-form--main"
        );

        this.mainProductInfo = document.querySelector(
          ".m-main-product--info"
        );

        this.mainAddToCart = this.mainProductForm
          ? this.mainProductForm.querySelector(".m-add-to-cart")
          : null;

        this.mainDynamicCheckout = this.mainProductForm
          ? this.mainProductForm.querySelector(
              this.selectors.buyNowBtn
            )
          : null;

        this.disableSelectedVariantDefault =
          this.mainProduct.dataset.disableSelectedVariantDefault ===
          "true";

        this.domNodes = queryDomNodes(
          this.selectors,
          this.container
        );

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty(
            "--m-translate-y",
            0
          );
          return;
        }

        this.variantData = this.getVariantData();

        const headerHeight =
          MinimogSettings.headerHeight || 66;

        const rootMargin =
          `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty(
                    "--m-translate-y",
                    0
                  );
                } else {
                  this.container.style.setProperty(
                    "--m-translate-y",
                    "100%"
                  );
                }

                document.documentElement.classList[
                  entry.intersectionRatio !== 1
                    ? "add"
                    : "remove"
                ]("stick-atc-show");
              });
            },
            {
              threshold: 1,
              rootMargin,
            }
          );
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;

        if (prodTitle) {
          prodTitle.addEventListener(
            "click",
            () => __scrollToTop()
          );
        }

        if (mainImage) {
          mainImage.addEventListener(
            "click",
            () => __scrollToTop()
          );
        }

        this.handleCustomFields();

        this.setObserveTarget();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(
          MinimogTheme.config.mediaQueryMobile
        );

        mql.onchange =
          this.setStickyAddToCartHeight.bind(this);

        this.setStickyAddToCartHeight();

        if (this.domNodes.select) {
          this.domNodes.select.addEventListener(
            "change",
            (e) => {
              const { target } = e;

              const variantPicker =
                this.mainProduct.querySelector(
                  "variant-picker"
                );

              const selectedVariantId =
                this.querySelector(
                  this.selectors.variantIdSelect
                ).value;

              this.currentVariant =
                this.variantData.find(
                  (variant) =>
                    variant.id ===
                    Number(selectedVariantId)
                );

              this.currentVariant
                ? this.toggleAddButton(
                    !this.currentVariant.available,
                    window.MinimogStrings.soldOut
                  )
                : this.toggleAddButton(
                    true,
                    window.MinimogStrings.unavailable
                  );

              // TYPEFASE — Update the sticky price.
              this.updateStickyPrice(
                this.currentVariant
              );

              const selectedOption =
                target.options[target.selectedIndex];

              if (!selectedOption) return;

              const selectedOptionIds = (
                selectedOption.dataset.options || ""
              )
                .split(",")
                .filter((id) => id);

              if (variantPicker) {
                selectedOptionIds.forEach((optionId) => {
                  const input =
                    variantPicker.querySelector(
                      `[data-option-value-id="${optionId}"]`
                    );

                  if (!input) return;

                  const { tagName } = input;

                  switch (tagName) {
                    case "OPTION":
                      const inputParent =
                        input.parentNode;

                      inputParent.value =
                        input.value;
                      break;

                    case "INPUT":
                      input.checked = true;
                      break;
                  }
                });

                variantPicker.dispatchEvent(
                  new Event("change")
                );
              }
            }
          );
        }
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector(
              '[type="application/json"]'
            ).textContent
          );

        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(
            this.mainProductForm
          );

          this.observeTarget =
            this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm =
          this.querySelector(".m-product-form");

        if (!productForm) return;

        const addButton =
          productForm.querySelector(
            '[name="add"]'
          );

        if (addButton) {
          this.toggleAddButton(
            true,
            window.MinimogStrings.unavailable
          );
        }
      }

      toggleAddButton(
        disable = true,
        text,
        modifyClass = true
      ) {
        const productForm =
          this.querySelector(".m-product-form");

        if (!productForm) return;

        const addButton =
          productForm.querySelector(
            '[name="add"]'
          );

        const addButtonText =
          productForm.querySelector(
            '[name="add"] > span.m-add-to-cart--text'
          );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute(
            "disabled",
            "disabled"
          );

          if (text && addButtonText) {
            addButtonText.textContent =
              text;
          }
        } else {
          addButton.removeAttribute(
            "disabled"
          );

          if (addButtonText) {
            addButtonText.innerHTML =
              window.MinimogStrings.addToCart;
          }
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        const urlParams =
          new URLSearchParams(
            window.location.search
          );

        if (urlParams.has("variant")) return;

        const pickerFields =
          this.querySelector(
            ".m-product-option--dropdown-select"
          );

        if (!pickerFields) return;

        pickerFields.value = "";

        this.setUnavailable();

        // TYPEFASE — Do not show a variant price
        // before a required selection is made.
        this.updateStickyPrice(null);
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          this.offsetHeight + "px"
        );

        window.MinimogSettings.stickyAddToCartHeight =
          this.offsetHeight;
      }

      // ========================================
      // TYPEFASE — DYNAMIC STICKY PRODUCT PRICE
      // ========================================

      updateStickyPrice(variant) {
        const priceElement =
          this.querySelector(
            ".tf-sticky-price__amount"
          );

        if (!priceElement) return;

        if (!variant) {
          priceElement.textContent =
            "Select options";
          return;
        }

        const variantSelect =
          this.domNodes.select;

        if (!variantSelect) return;

        const selectedOption =
          Array.from(
            variantSelect.options
          ).find(
            (option) =>
              Number(option.value) ===
              Number(variant.id)
          );

        if (!selectedOption) return;

        const priceText =
          selectedOption.textContent.trim();

        const separatorIndex =
          priceText.lastIndexOf(" - ");

        if (separatorIndex !== -1) {
          priceElement.textContent =
            priceText.substring(
              separatorIndex + 3
            );
        }
      }

      // ========================================
      // SYNC WITH MAIN PRODUCT VARIANTS
      // ========================================

      syncWithMainProductForm() {
        const variantInput =
          this.querySelector('[name="id"]');

        MinimogEvents.subscribe(
          MinimogTheme.pubSubEvents.variantChange,
          (e) => {
            const isMainProduct =
              e.data.sectionId ===
              this.mainProduct.dataset.sectionId;

            if (!isMainProduct) return;

            this.currentVariant =
              e.data.variant;

            // TYPEFASE — Keep sticky price
            // synchronized with selected variant.
            this.updateStickyPrice(
              this.currentVariant
            );

            if (this.currentVariant) {
              variantInput.value =
                e.data.variant.id;

              this.toggleAddButton(
                !this.currentVariant.available,
                window.MinimogStrings.soldOut
              );
            } else {
              variantInput.value = "";

              this.toggleAddButton(
                true,
                window.MinimogStrings.unavailable
              );
            }
          }
        );
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const {
          addToCart,
          buyNowBtn,
          foxkitBtn,
        } = this.domNodes;

        let hasCustomFieldRequired = false;

        const customFields =
          document.querySelectorAll(
            ".m-main-product--info .m-product-custom-field"
          );

        let customFieldFirst =
          customFields[0];

        customFields &&
          customFields.forEach((item) => {
            const field =
              item.querySelector(".form-field");

            if (
              field &&
              field.value === "" &&
              field.hasAttribute("required")
            ) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              e.stopPropagation();

              __scrollToTop(
                this.mainProductInfo,
                () => this.mainAddToCart.click()
              );
            }
          );

        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing =
                validateForm(
                  this.mainProductInfo
                );

              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();

                __scrollToTop(
                  this.mainProductInfo,
                  () =>
                    this.mainDynamicCheckout.click()
                );
              }
            },
            true
          );
        }

        if (foxkitBtn) {
          foxkitBtn.addEventListener(
            "click",
            (e) => {
              e.preventDefault();

              __scrollToTop(
                this.mainProductInfo,
                () => this.mainAddToCart.click()
              );
            }
          );
        }
      }
    }
  );
}
